// DietHistoryTable.jsx
import React from "react";
import { Table } from "antd";
import dayjs from "dayjs";

const DietHistoryTable = ({ data }) => {
  const columns = [
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      render: (text) => dayjs(text, "HH:mm:ss").format("hh:mm A"),
      width: 80,
    },
    {
      title: "Item",
      dataIndex: "item_name",
      key: "item_name",
      render: (_, record) => `${record?.item_name} x ${record?.quantity}`,
      width: 200,
    },
    {
      title: "Energy",
      dataIndex: "calories",
      key: "calories",
      width: 60,
    },
    {
      title: "Protein",
      dataIndex: "protien",
      key: "protien",
      width: 60,
    },
    {
      title: "Carbs",
      dataIndex: "carbohydrates",
      key: "carbohydrates",
      width: 60,
    },
    {
      title: "Sodium",
      dataIndex: "sodium",
      key: "sodium",
      width: 60,
    },
    {
      title: "Potassium",
      dataIndex: "potassium",
      key: "potassium",
      width: 60,
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (text) => text || "-",
      width: 400,
    },
  ];

  return (
    <Table
      size="small"
      bordered
      columns={columns}
      dataSource={data || []}
      rowKey="id"
      pagination={false}
      // scroll={{ x: "max-content" }}
    />
  );
};

export default DietHistoryTable;
